module.exports = __webpack_public_path__ + "img/rejected.c0ec12b7.svg";